import {Navigate, Outlet} from "react-router";

function ProtectedRoute() {
    return localStorage.getItem('inventory') ? <Outlet/> : <Navigate to="/login" replace/>;
}

export default ProtectedRoute;